import React, { useContext } from "react";

import { EventContext, LookupContext } from "@gp/components";

import { SportSubheaderIcons } from "./SportSubheaderIcons";
import { SportSubheaderTitle } from "./SportSubheaderTitle";

export function SportSubheader() {
	const event = useContext(EventContext);
	const { sports, tournaments, categories } = useContext(LookupContext);

	const sport = sports.get(event.sportId);
	const category = categories.get(event.sportCategoryId);
	const tournament = tournaments.get(event.tournamentId);

	return (
		<>
			<SportSubheaderIcons
				sportAbrv={sport?.abrv || ""}
				categoryAbrv={category?.abrv || ""}
			/>
			<SportSubheaderTitle
				categoryName={category?.name || ""}
				tournamentName={tournament?.name || ""}
			/>
		</>
	);
}
